<script lang="ts">
  import { IlluminationMeter, fade } from "@/libs/ui"
  import type { ComponentProps } from "svelte"
  import type { ThresholdRanges } from "../../checks"

  let {
    value,
    thresholds,
  }: {
    value: ComponentProps<typeof IlluminationMeter>["value"]
    thresholds: ThresholdRanges
  } = $props()
</script>

<IlluminationMeter
  {value}
  optimum={thresholds.good[0]}
  max={thresholds.perfect[0]}
  transition={fade}
/>
